import { useGetFundsRequestInfoQuery } from "../funds-requests/queries/funds-request-info";
import { fmtAmountCommon } from "../offers";

export const useApplicationSummaryList = (): { amount: string | null; expiry: string | null } => {
  const {
    data: { currentStep, applicationAmountInLowestDenomination, applicationCurrency, applicationExpiryDate },
  } = useGetFundsRequestInfoQuery();

  if (!!currentStep && ["expired", "disqualified", "contract_signed"].includes(currentStep)) {
    return {
      amount: null,
      expiry: null,
    };
  }

  return {
    amount:
      applicationAmountInLowestDenomination && applicationCurrency
        ? fmtAmountCommon(applicationAmountInLowestDenomination, applicationCurrency)
        : null,
    expiry: applicationExpiryDate ?? null,
  };
};
